import React, { useState } from 'react';
import EnrolledPlanCard from './EnrolledPlanCard';

export default function StudentDashboard({ studentUser, enrollments, batches, pools, setActiveTab, setEnrollments }) {
  // Global flag to ensure only one session is active across all cards at any given time
  const [globalActiveEnrollmentId, setGlobalActiveEnrollmentId] = useState(null);

  // --- VIEW PRECOMPUTATION INTERFACES ---
  const displayUser = studentUser;
  const myEnrollments = enrollments.filter(e => e.studentId === displayUser.id || e.studentId === displayUser.regId);
  const totalBalanceHours = myEnrollments.reduce((acc, curr) => acc + parseFloat(curr.balanceHours), 0);

  const explorePrograms = [
    { id: 'Personal Training', icon: 'fa-user-clock', desc: '1-on-1 coaching to perfect your technique.' },
    { id: 'Group Training', icon: 'fa-users', desc: 'Train with peers and push your limits.' },
    { id: 'Premium Membership', icon: 'fa-star', desc: 'Unlimited access to all facilities.' }
  ];

  return (
    <div className="admin-card" style={{ overflowY: 'auto' }}>
      
      {/* HEADER WITH PROFILE */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem', flexWrap: 'wrap', gap: '15px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <img 
            src={displayUser.profilePic || `https://ui-avatars.com/api/?name=${displayUser.name.replace(' ', '+')}&background=fbbf24&color=0f172a&size=150`} 
            alt="Profile" 
            style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', border: '3px solid var(--accent-gold)' }} 
          />
          <div>
            <h2 style={{ margin: '0 0 5px 0', border: 'none', padding: 0 }}>Hello, {displayUser.name}!</h2>
            <p style={{ color: 'var(--text-gray)', margin: 0 }}>Registration ID: <strong style={{ color: 'var(--accent-gold)' }}>{displayUser.regId || displayUser.id}</strong></p>
          </div>
        </div>
        
        <div style={{ textAlign: 'right', backgroundColor: 'rgba(255,255,255,0.05)', padding: '15px 25px', borderRadius: '10px', border: '1px solid rgba(255,255,255,0.1)' }}>
          <p style={{ margin: '0 0 5px 0', color: 'var(--text-gray)', fontSize: '0.9rem', textTransform: 'uppercase' }}>Total Remaining Hours</p>
          <h2 style={{ margin: 0, color: totalBalanceHours <= 8 ? '#ef4444' : '#10b981', fontSize: '2rem', border: 'none', padding: 0 }}>
            {totalBalanceHours.toFixed(2)} <span style={{fontSize: '1rem', color: 'var(--text-gray)'}}>Hrs</span>
          </h2>
        </div>
      </div>

      {/* ENROLLED PLANS ITERATOR */}
      <h3 style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px' }}>My Enrolled Plans</h3>
      
      {myEnrollments.length === 0 ? (
        <p style={{ color: 'var(--text-gray)' }}>You are not currently enrolled in any training plans.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '15px', marginBottom: '3rem' }}>
          {myEnrollments.map(enroll => (
            <EnrolledPlanCard 
              key={enroll.id}
              enroll={enroll}
              batches={batches}
              setEnrollments={setEnrollments}
              globalActiveEnrollmentId={globalActiveEnrollmentId}
              setGlobalActiveEnrollmentId={setGlobalActiveEnrollmentId}
            />
          ))}
        </div>
      )}

      {/* UPSELL / EXPLORE SECTION */}
      <h3 style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px' }}>Ready to level up? Explore Programs</h3>
      <p style={{ color: 'var(--text-gray)', marginBottom: '15px' }}>Discover new ways to reach your fitness goals at our pools.</p>
      
      <div className="dashboard-grid">
        {explorePrograms.map(prog => (
          <div key={prog.id} className="metric-card" style={{ flexDirection: 'column', alignItems: 'flex-start', borderLeft: 'none', borderTop: '4px solid var(--accent-blue)', cursor: 'pointer' }} onClick={() => setActiveTab('programs')}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
              <i className={`fas ${prog.icon}`} style={{ fontSize: '2rem', color: 'var(--accent-gold)' }}></i>
              <h4 style={{ margin: 0, color: 'white', fontSize: '1.2rem' }}>{prog.id}</h4>
            </div>
            <p style={{ margin: 0, color: 'var(--text-gray)', fontSize: '0.9rem', lineHeight: '1.4', textTransform: 'none', letterSpacing: 'normal', fontWeight: 'normal' }}>
              {prog.desc}
            </p>
            <span style={{ color: 'var(--accent-blue)', fontSize: '0.85rem', marginTop: '15px', fontWeight: 'bold' }}>View Available Pools <i className="fas fa-arrow-right"></i></span>
          </div>
        ))}
      </div>
      
    </div>
  );
}